import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { Skeleton, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import { useOpsContext } from "../../../ContextsAndProvider/OpsContext";
import { getDocumentDashboard } from "../../api/FillableDocument.js";
import { ViewDateTime } from "../../../utils/DateSupport";
import { AttachementModal } from "../../apps/AppointmentRequests/AttachementModal";
import ViewIcon from "../../../assets/images/view.png";
import "./OpsDashboard.css";

const OpsDocumentsTab = () => {
  const { selectedOrganization, selectedPractitioner } = useOpsContext();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statusFilter, setStatusFilter] = useState("assigned");
  const [showAttachmentModal, setShowAttachmentModal] = useState(false);
  const [attachmentUrl, setAttachmentUrl] = useState("");
  const [docData, setDocData] = useState(null);

  const handleShowFile = (data) => {
    setShowAttachmentModal(true);
    setAttachmentUrl(data?.content?.[0]?.attachment?.url);
    setDocData(data);
  };

  useEffect(() => {
    if (!selectedOrganization || !selectedPractitioner?.value) {
      setList([]);
      return;
    }
    setLoading(true);
    getDocumentDashboard({
      status: statusFilter,
      practitionerId: selectedPractitioner.value,
      orgId: selectedOrganization,
    })
      .then((res) => setList(res?.data || []))
      .catch(() => setList([]))
      .finally(() => setLoading(false));
  }, [selectedOrganization, selectedPractitioner?.value, statusFilter]);

  if (!selectedOrganization || !selectedPractitioner) return null;

  return (
    <div className="ops-dashboard-content">
      <div className="ops-doc-filters" style={{ marginBottom: 12 }}>
        {["assigned", "acknowledged", "completed", "cancelled"].map((s) => (
          <button
            key={s}
            type="button"
            className="ops-btn-status"
            style={{
              marginRight: 8,
              padding: "6px 12px",
              border: statusFilter === s ? "1px solid #005da8" : "1px solid #ccc",
              background: statusFilter === s ? "#e9f5ff" : "#fff",
              borderRadius: 4,
              cursor: "pointer",
            }}
            onClick={() => setStatusFilter(s)}
          >
            {s.charAt(0).toUpperCase() + s.slice(1)}
          </button>
        ))}
      </div>
      <div className="table-wrap ops-encounter-table-wrap">
        <Table responsive>
          <thead>
            <tr>
              <th>Date/Time</th>
              <th>Source</th>
              <th>Category</th>
              <th>Uploaded by</th>
              <th>Pages</th>
              <th>Patient</th>
              <th style={{ textAlign: "center" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              [1, 2, 3, 4, 5].map((i) => (
                <tr key={i}>
                  <td colSpan={7}><Skeleton animation="wave" /></td>
                </tr>
              ))
            ) : list.length > 0 ? (
              list.map((doc) => {
                const capitalize = (str) => str ? str.split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ') : '-';
                return (
                  <tr key={doc.id}>
                    <td>{doc?.createdAt ? ViewDateTime(doc.createdAt) : "-"}</td>
                    <td>{capitalize(doc?.author?.[0]?.display)}</td>
                    <td>{doc?.category?.[0]?.coding?.[0]?.display || "-"}</td>
                    <td>{doc?.submittedBy?.coding?.[0]?.code === "fax" ? doc?.submittedBy?.coding?.[0]?.display : capitalize(doc?.submittedBy?.name) || "-"}</td>
                    <td>{doc?.numPages || "-"}</td>
                    <td style={{ textTransform: "capitalize" }}>{doc?.subject?.display || "-"}</td>
                    <td>
                      <div className="action-wrap" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <Tooltip title="View">
                          <Link to="" variant="primary" className="view-btn" onClick={() => handleShowFile(doc)}>
                            <img src={ViewIcon} alt="View PDF" />
                          </Link>
                        </Tooltip>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={7} style={{ textAlign: "center" }}>No documents</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      {showAttachmentModal && (
        <AttachementModal
          fromDocument={true}
          modalShow={showAttachmentModal}
          url={attachmentUrl}
          docData={docData}
          handleShow={() => setShowAttachmentModal(false)}
        />
      )}
    </div>
  );
};

export default OpsDocumentsTab;
